import { render, staticRenderFns } from "./VendorList_List_Action.vue?vue&type=template&id=673149e0&"
import script from "./VendorList_List_Action.vue?vue&type=script&lang=js&"
export * from "./VendorList_List_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports